export default __webpack_public_path__ + "static/media/czechgo-logo.b9a22518.png";